import React, { useEffect, useState } from 'react';
import {
Modal, ModalHeader, ModalBody,
Input, ListGroup, ListGroupItem,
ModalFooter,
Button
} from 'reactstrap';

const ListPicker = ({ isOpen, toggle, items, selectedItems, onConfirm, title }) => {

    const [search, setSearch] = useState('');
    const [filteredItems, setFilteredItems] = useState(items || []);
    const [selectedItem, setSelectedItem] = useState(selectedItems?.[0] || null);

    // TODO: handle multiple selection
    const handleSelectItem = (item) => {
        if (item.id === selectedItem?.id) {
            setSelectedItem(null);
        } else {
            setSelectedItem(item);
        }
    };

    useEffect(() => {
        if (!items || !items.length) {
            setFilteredItems([]);
            return;
        }
        setFilteredItems(
            items.filter(item =>
                item.name.toLowerCase().includes(search.toLowerCase())
            )
        );
    }, [items, search]);

return (
    <Modal
        isOpen={isOpen}
        toggle={toggle}
        centered
    >
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
            <Input
                type="search"
                placeholder="Search..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                className="mb-3"
            />
            <ListGroup>
                {filteredItems.map(item => (
                    <ListGroupItem
                        tag="a"
                        key={item.id}
                        active={selectedItem?.id === item.id}
                        action
                        onClick={() => handleSelectItem(item)}>
                        {item.name}
                    </ListGroupItem>
                ))}
            </ListGroup>
        </ModalBody>
        <ModalFooter>
            <Button color="secondary" onClick={toggle}>Cancel</Button>
            <Button className="promote" onClick={() => onConfirm(selectedItem)}>Confirm Destination</Button>
        </ModalFooter>
    </Modal>
);
};

export default ListPicker;
